<template>
  <div class="g-box">
    <!--ぱんくず-->
    <breadcrumb :pathList="pathList">
    </breadcrumb>
    <!--/ぱんくず-->
    <main class="g-content">
      <h1 class="g-h-1 g-rainbow">Links</h1>
      <section class="g-unit-xl">
        <ul class="g-list g-list-disc">
          <li><a class="g-link" href="https://www.minpaku.ac.jp/en/research/project/ifm" target="_blank">Info-Forum Museum<i class="g-i g-i-blank" aria-hidden="true"></i></a></li>
          <li><a class="g-link" href="https://htq.minpaku.ac.jp/menu/database_eng.html" target="_blank">List of Databases in MINPAKU<i class="g-i g-i-blank" aria-hidden="true"></i></a></li>
          <li><a class="g-link" href="https://www.minpaku.ac.jp/en" target="_blank">National Museum of Ethnology<i class="g-i g-i-blank" aria-hidden="true"></i></a></li>
        </ul>
      </section>
    </main>
  </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb.vue'

export default {
  components: {
    breadcrumb
  },
  computed: {
    // パン屑リスト
    pathList: function() {
      return [
        { path: '/', text: 'Site.home' },
        { path: '/link', text: 'Site.links' },
      ]
    },
  }
}

</script>